export default __webpack_public_path__ + "static/media/HR.47396110.ico";